import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { Quote, Star } from 'lucide-react';

const TESTIMONIALS = [
  {
    quote: "ArcheanX cut our exterior inspection time by nearly 70%. What used to take hours now takes minutes — without compromising on accuracy or compliance.",
    name: "Austin C.",
    role: "MRO Technician"
  },
  {
    quote: "The digital twin and historical comparison features have been a game-changer for our fleet planning. We catch corrosion and fatigue issues months earlier than before.",
    name: "Daniel Diaz",
    role: "Director of Maintenance"
  },
  {
    quote: "Hardware-agnostic and pilot-friendly. Our crews adopted the platform within a week. Compliance reporting that used to be a headache is now automated.",
    name: "William F.",
    role: "CEO of MRO"
  }
];

export const Testimonials = () => {
  return (
    <section id="testimonials" data-testid="testimonials-section" className="py-20 px-6 bg-orange-50/40">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center space-y-4 mb-16">
          <Badge className="bg-orange-100 text-orange-700 border-orange-200">
            Testimonials
          </Badge>
          <h2 className="text-4xl md:text-5xl font-bold text-black">Trusted by Aviation Leaders</h2>
          <p className="text-xl text-gray-700 max-w-2xl mx-auto">
            Hear how MRO providers, operators, and fleet managers are transforming inspections with ArcheanX.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t, idx) => (
            <Card
              key={idx}
              data-testid={`testimonial-card-${idx}`}
              className="border-gray-200 bg-white hover:shadow-xl transition-shadow duration-300 relative"
            >
              <CardContent className="pt-8 pb-6 px-6 flex flex-col h-full">
                <Quote className="w-8 h-8 text-orange-500 mb-4" />
                <p className="text-base text-gray-800 leading-relaxed flex-grow mb-6">
                  "{t.quote}"
                </p>
                <div className="flex items-center gap-1 mb-4">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} className="w-4 h-4 fill-orange-500 text-orange-500" />
                  ))}
                </div>
                <div className="border-t border-gray-200 pt-4">
                  <p className="text-base font-bold text-black">{t.name}</p>
                  <p className="text-sm text-orange-600 font-medium">{t.role}</p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};
